import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Skeleton } from 'primereact/skeleton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import Conexao from '../../../providers/Conexao';
import Layout from '../../Layout';
import fontConfig from '../../../Componentes/FontConfig';
import { useLocation } from 'react-router-dom';
import { OverlayPanel } from 'primereact/overlaypanel';
import { SplitButton } from 'primereact/splitbutton';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import FormEdicaoCliente from './FormEdicaoCliente';
import { Divider } from 'primereact/divider';
import { Tag } from 'primereact/tag';
import { InputSwitch } from "primereact/inputswitch";
import { SpeedDial } from 'primereact/speeddial';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import BotaoEditar from '../../../Componentes/BotaoEditar';
import BotaoExcluir from '../../../Componentes/BotaoExcluir';
import SidebarClientes from './SidebarClientes';
import FormNovoCliente from './FormNovoCliente';
import {Icones} from '../../../Componentes/FontConfig'

export default function ClientesRelatorios(props) {
    const toast = React.useRef(null); // Ref para o Toast
    const [cliente, setCliente]= useState([]);

    const [fieldsFound, setFieldsFound] = useState([]);

    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const location = useLocation();

    const { dataEmpresa } = location.state || {};

    const [overlayVisible, setOverlayVisible] = useState(false);

    const op = useRef(null); // Referência para o OverlayPanel
    const [selectAll, setSelectAll] = useState(false);
    const overlayBtn = useRef(null); // Referência para o botão de filtro
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    const [clientes, setClientes] = useState([]);
    const [selectedClientes, setSelectedClientes]= useState([]);
    const [clienteEdicao, setClienteEdicao] = useState([]);

    const [sideBarOpened, setSideBarOpened] = useState(false);
     
    const resetCliente = () =>{
        setCliente({
            ...cliente, 
            statusCadastro : 'cadastro', 
            idcliente :  -1,
            razaosocial :  "",
            nomefantasia :  "",
            cpf_cnpj :  "",
            rg_insc :  "",
            logradouro :  "",
            numero :  "",
            complemento :  "",
            bairro :  "",
            cep :  "",
            cidade :  "",
            estado :  "",
            telefonecomercial :  "",
            telefonecelular :  "",
            email :  "",
            ativo :  "t",
        })
    }
    const [usuario, setUsuario]= useState([]);
    const [visibleLeft, setVisibleLeft] = useState(false);

    const [verInativos, setVerInativos]= useState(false);

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        idcliente: { value: '', matchMode: FilterMatchMode.CONTAINS },
        razaosocial: { value: '', matchMode: FilterMatchMode.EQUALS },
        nomefantasia: { value: '', matchMode: FilterMatchMode.EQUALS },
        cpf_cnpj: { value: '', matchMode: FilterMatchMode.STARTS_WITH },
        rg_insc: { value: '', matchMode: FilterMatchMode.STARTS_WITH },
        cidade: { value: '', matchMode: FilterMatchMode.EQUALS },
        estado: { value: '', matchMode: FilterMatchMode.EQUALS },
        ativo: { value: 't', matchMode: FilterMatchMode.EQUALS }
    });

   const [isMobile, setIsMobile] = useState(false);

       useEffect(() => {
                   // Função que será chamada quando o tamanho da janela mudar
                   const handleResize = () => {
                    setIsMobile(window.innerWidth < 768);
                   };
           
                   // Adiciona o listener de resize
                   window.addEventListener('resize', handleResize);
           
                   // Limpeza do evento quando o componente for desmontado
                   return () => {
                       window.removeEventListener('resize', handleResize);
                   };
               }, []);


    useEffect(() => {

        setFilters(prevFilters => ({
            ...prevFilters,
            ativo: verInativos === true ? { value: null, matchMode: FilterMatchMode.EQUALS } : { value: 't', matchMode: FilterMatchMode.EQUALS }
        }));

    }, [verInativos]);



   
    const firstGet = useRef(false)

    useEffect(() => {
        if(!firstGet.current){
            firstGet.current = true
            getData();
        }
    }, []);

    useEffect(() => {
        if(!visible){
            setUsuario([])
        }
       

    }, [visible]);

    const getData = () => {
        console.log(dataEmpresa)
        clearFilters()

        setLoading(true);

        setTimeout(() => {

            Conexao.post('clientesController/getAllClientes?inativos:sim', { 
               idusuario : dataEmpresa.idrevenda, 
               idempresa : dataEmpresa.idempresa, 
               idcliente : dataEmpresa.idcliente, 
               inativos : 'ver-todos'
             })
                .then(response => {

                    if (response.status === 200 && response.data.status === 'OK') {

                        setClientes(response.data.payload);

                        setLoading(false);

                    } else {
                        setClientes([])
                        setLoading(false);
                      //  showMessageToast('warn', "Não foi possível recuperar dados")
                    }

                }).catch(error => {
                    setClientes([])
                    setLoading(false);
                    showMessageToast('error', "Não foi possível recuperar dados")
                });

        }, 1000);
    };

  
    const showMessageToast = (severity, msg) => {
        switch(severity){
            case "error":
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "success":
                toast.current.show({
                    severity: "success",
                    summary: "Sucess",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "warn":
                toast.current.show({
                    severity: "warn",
                    summary: "Warning",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

        }
        
      };


  const handleFilterChange = (e, field) => {
    const value = e.target.value;

    setFilters(prevFilters => ({
        ...prevFilters,
        [field]: prevFilters[field] 
            ? { value, matchMode: prevFilters[field].matchMode } 
            : { value, matchMode: FilterMatchMode.CONTAINS } // Define um matchMode padrão
    }));
    };


    const handleFilterConfirm = () => {
        // Aqui você pode aplicar os filtros ao DataTable ou fazer outras ações necessárias
        setOverlayVisible(false); // Fecha o overlay após aplicar os filtros
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value.toLowerCase();
        setGlobalFilterValue(value);
    
        // Atualizar o filtro global corretamente
        setFilters(prevFilters => ({
            ...prevFilters,
            global: { ...prevFilters.global, value }
        }));
    
        // Identificar os campos onde o filtro foi encontrado
        const foundFields = new Set();
        const fields = ['idcliente', 'razaosocial', 'nomefantasia', 'cpf_cnpj', 'rg_insc', 'cidade', 'estado', 'ativo'];
    
        clientes.forEach(cliente => {
            fields.forEach(field => {
                const fieldValue = cliente[field]?.toString().toLowerCase() || ""; // 🔹 Evita erro ao chamar toString()
                if (fieldValue.includes(value)) {
                    foundFields.add(field);
                }
            });
        });
    
        setFieldsFound([...foundFields]); // Converte Set para array
    };
    
   
    
    
    const renderBotaoEditar = (row, opcao) => {
  
        return (
            <Button 
                icon="pi pi-pencil"
                onClick={() => {
                    console.log("Opções para:", row)
                    setCliente(row)
                }} 
                disabled={loading}
                tooltip="Editar dados da empresa" tooltipOptions={{ position: 'left' }}
            />
        );
    };

    const renderBotaoOpcoes= (row, opcao) => {
  
        return (
            <Button 
                disabled={row.ativo === 'f'}
                icon= "pi pi-cog"
                onClick={() => {
                    console.log("Opções para:", row)
                    setClienteEdicao(row)
                    setSideBarOpened(true)
                }} 
    
                tooltip="Acessar opções:Edição, Ativação/Desativação, Acesso Clientes, Exclusão" tooltipOptions={{ position: 'left' }}
            />
        );
    };
    const renderStatusRow= (row, opcao) => {

        return (
            row.ativo =='t' ? <Tag severity="success" value="ATIVO" style={{cursor :'pointer'}} onClick={()=>{
                confirmDialog({
                        message: 'Confirma a INATIVAÇÃO do cliente agora?',
                        header: 'Confirmação',
                        icon: 'pi pi-exclamation-triangle',
                        acceptLabel: 'Sim',
                        rejectLabel: 'Não',
                        accept: () => {
                              disableRegistro(row)
                        } 
                    });
            }}></Tag> : <Tag severity="danger" value="INATIVO" style={{cursor :'pointer'}}  onClick={()=>{
                confirmDialog({
                        message: 'Confirma a ATIVAÇÃO do cliente agora?',
                        header: 'Confirmação',
                        icon: 'pi pi-exclamation-triangle',
                        acceptLabel: 'Sim',
                        rejectLabel: 'Não',
                        accept: () => {
                            enableRegistro(row)
                        } 
                    });
            }}></Tag>
        );
    };
    const disableRegistro = (row) =>{
        Conexao.get('clientesController/disableRegistro?idempresa='+row.idempresa+'&idcliente='+row.idcliente)
                .then(response => {

                    if (response.status === 200 && response.data.status === 'OK') {
                         setClientes((prevData) =>
                            prevData.map(cliente =>
                                cliente.idcliente === row.idcliente ? {...cliente, ativo : 'f'} : cliente
                            )
                        );
                        showMessageToast('success', "Registro atualizado com sucesso!")

                    } else {
                      showMessageToast('warn', "Não foi possível atualizar registro")

                    }

                }).catch(error => {
                  showMessageToast('error', "Não foi possível atualizar registro")
                });
    }


    const enableRegistro = (row) =>{
        Conexao.get('clientesController/enableRegistro?idempresa='+row.idempresa+'&idcliente='+row.idcliente)
                .then(response => {

                    if (response.status === 200 && response.data.status === 'OK') {
                         setClientes((prevData) =>
                            prevData.map(cliente =>
                               cliente.idcliente === row.idcliente ? {...cliente, ativo : 't'} : cliente
                            )
                        );
                        showMessageToast('success', "Registro atualizado com sucesso!")

                    } else {
                      showMessageToast('warn', "Não foi possível atualizar registro")

                    }

                }).catch(error => {
                  showMessageToast('error', "Não foi possível atualizar registro")
                });
    }



    const renderHeader = () => {
        return (
            <div className="flex justify-content-between align-items-center" style={{paddingBottom : '10px', paddingTop : '30px', paddingLeft : '0px'}}>
               
                <div className="flex align-items-center gap-2">
                    <IconField iconPosition="left">
                        <InputIcon className="pi pi-search" />
                        <InputText 
                            value={globalFilterValue} 
                            onChange={onGlobalFilterChange} 
                            placeholder="Pesquisa global" 
                            tooltip="Pesquise por qualquer campo da tabela" tooltipOptions={{ position: 'bottom' }}
                        />
                    </IconField>
                    <Button 
                        icon="pi pi-filter-slash" 
                        className="p-button-secondary p-button-sm" 
                        onClick={clearFilters} 
                        tooltip="Limpar todos os filtros" tooltipOptions={{ position: 'bottom' }}
                    />
                    
                    <Button 
                        icon="pi pi-sync" 
                        className= "p-button-secondary p-button-sm" 
                        onClick={getData} 
                        tooltip="Buscar dados..." tooltipOptions={{ position: 'bottom' }}
                    />        
                    
                </div>
               
            </div>
        );
    };
    

    const renderFooter = () => {
        if (fieldsFound.length === 0) {
            return  <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Total de registros: {clientes.length} 
        </div>
        }
        
        return <>
        <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Total de registros: {clientes.length} 
        </div>
        <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Filtro encontrado em: {fieldsFound.join(', ')}
        </div>
    </>
    };

    const clearFilters = () => {
        setGlobalFilterValue('');
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            idcliente: { value: '', matchMode: FilterMatchMode.CONTAINS },
            razaosocial: { value: '', matchMode: FilterMatchMode.EQUALS },
            nomefantasia: { value: '', matchMode: FilterMatchMode.EQUALS },
            cpf_cnpj: { value: '', matchMode: FilterMatchMode.STARTS_WITH },
            rg_insc: { value: '', matchMode: FilterMatchMode.STARTS_WITH },
            cidade: { value: '', matchMode: FilterMatchMode.EQUALS },
            estado: { value: '', matchMode: FilterMatchMode.EQUALS },
            ativo: { value: 't', matchMode: FilterMatchMode.EQUALS }
        });
        setFieldsFound([]); // Resetando os campos encontrados
    };



    useEffect(()=>{

    }, [fieldsFound])
    

    const toastBottomCenter = useRef(null);
    
    
    const showMessage = (severity, title, text) => {
        const label = title;

        toastBottomCenter.current.show({ severity: severity, title: label, detail: text, life: 3000 });
    };

    const deleteClienteRevenda = (idempresa, idcliente) =>{
        setLoading(true)
        Conexao.post('clientesController/deleteClienteRevenda', {
            idempresa : idempresa, 
            idcliente : idcliente
        }).then(response =>{
            if (response.status === 200 && response.data.status === 'OK') {

                setClientes(clientes.filter(item => item.idcliente !== idcliente));

                setLoading(false);
                showMessageToast('success', 'Registro excluido com sucesso!')
            } else {
                setClientes([])
                setLoading(false);
                  showMessageToast('warn', "Não foi possível excluir registro")
            }
        }).catch(error =>{
            
            showMessageToast('error', "Não foi possível excluir registro")
        })
    }


    const onSelectionChange = (event) => {
            const value = event.value;
            setSelectedClientes(value);
    
            // Atualiza o estado do botão "Selecionar Todos"
            const allSelected = clientes.every(c => value.some(s => s.idcoleta === c.idcoleta));
            setSelectAll(allSelected);
        };

    
        const onSelectAllChange = (event) => {
            const checked = event.checked;
    
            if (checked) {
                const newSelected = [
                    ...clientes.filter(s => !clientes.some(c => c.idcoleta === s.idcoleta)),
                    ...clientes
                ];
                setSelectedClientes(newSelected);
            } else {
                const remaining = selectedClientes.filter(s => !clientes.some(c => c.idcoleta === s.idcoleta));
                setSelectedClientes(remaining);
            }
    
            setSelectAll(checked);
        };


    return (
        <Layout loading={loading} >
            <div className="p-2">
                
                <Toast ref={toastBottomCenter} position="top-right" />
                <div className="border-round-lg surface-card shadow-0 p-2">
                    {/* Botão para abrir o OverlayPanel */}
                    
                
                        <DataTable
                            header={renderHeader()}  
                            footer={renderFooter} 
                            value={clientes}
                            paginator                 
                            rows={10} // Número de itens por página
                            rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
                            responsiveLayout="scroll"
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                            tableStyle={{ minWidth: '35rem', fontSize : '11px' }}
                            bodyStyle={{fontSize : '10px'}}                            
                            filters={filters} // Aplicando os filtros
                            filterDisplay="menu"// Exibe os filtros como menu pop-up

                        >
            
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '6%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                field="cpf_cnpj" 
                                header="CNPJ/CPF" 
                                name="cpf_cnpj" 
                                body={loading && !sideBarOpened ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                sortable  
                                filterPlaceholder="Filtrar pelo CNPJ/CPF" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '20%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                field="razaosocial" 
                                name="razaosocial" 
                                header="Razão Social/Nome" 

                                body={loading && !sideBarOpened ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                sortable 
                                filterPlaceholder="Filtrar pela razão social" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '10%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                field="cidade" 
                                header="Cidade" 
                                name="cidade" 
                                body={loading && !sideBarOpened ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                sortable 
                                filterPlaceholder="Filtrar pela Cidade" />

                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '10%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                field="cidade" 
                                header="Cidade" 
                                name="cidade" 
                                body={loading && !sideBarOpened ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                sortable 
                                filterPlaceholder="Filtrar pela Cidade" />
                            
                
                        </DataTable>
                    
                </div>

               
            </div>
            <OverlayPanel ref={op} style={{ width: '300px' }}>
                                <div className="p-3">
                                    <h4>Filtros</h4>
                                    <div className="p-field">
                                        <label htmlFor="idempresa">Código</label>
                                        <InputText
                                            id="idcliente"
                                            value={filters.idcliente.value}
                                            onChange={(e) => handleFilterChange(e, 'idcliente')}
                                        />
                                    </div>
                                    <div className="p-field">
                                        <label htmlFor="razaosocial">Razão Social</label>
                                        <InputText
                                            id="razaosocial"
                                            value={filters.razaosocial.value}
                                            onChange={(e) => handleFilterChange(e, 'razaosocial')}
                                        />
                                    </div>
                                    <div className="p-field">
                                        <label htmlFor="cidade">Cidade</label>
                                        <InputText
                                            id="cidade"
                                            value={filters.cidade.value}
                                            onChange={(e) => handleFilterChange(e, 'cidade')}
                                        />
                                    </div>
                                    <div className="p-field">
                                        <label htmlFor="estado">UF</label>
                                        <InputText
                                            id="estado"
                                            value={filters.estado.value}
                                            onChange={(e) => handleFilterChange(e, 'estado')}
                                        />
                                    </div>
                                    <Button label="Aplicar Filtro" icon="pi pi-check" onClick={handleFilterConfirm} />
                                </div>
                            </OverlayPanel>
             <Toast ref={toast} />
             <SidebarClientes 
                cliente = {clienteEdicao} 
                isMobile={isMobile}
                Conexao={Conexao}
                setLoading ={setLoading}
                setSideBarOpened = {setSideBarOpened}
                dataEmpresa = {dataEmpresa}
                showMessage ={showMessage}
                setClientes = {(data)=>{                    
                    setClientes(prevClientes => [...prevClientes, data]);                    
                }}
                updateClientes = {(data)=>{
                    
                    setClientes(prevClientes => data);
                    
                }}
                setCliente={(val)=>{
                    setClienteEdicao(val)
                    
                    }}/>
             
        </Layout>
    );
}
